"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Platform = _interopRequireDefault(require("react-native-web/dist/cjs/exports/Platform"));
var _platform = _interopRequireDefault(require("./platform"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// Allows consuming libraries that might not have a direct dependency on
// React Native to check what the current platform is.
// Particularly useful for validating Jest config: it is possible for Jest to
// get configured such that Platform.OS returns a different mocked value to the
// OS being used to select files by platform suffix (e.g. .web, .native).
var _default = exports.default = {
  OS: _Platform.default.OS,
  fileSuffix: _platform.default
};